import { render } from "./BaseSpinner.vue?vue&type=template&id=4147b9a0&scoped=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=4147b9a0&scoped=true&lang=css"

import exportComponent from "/Users/lopollo/projects/CVUE/CVUE-coaches/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4147b9a0"]])

export default __exports__